// Get Code Random
export const GET_CODE_RANDOM_REQUEST = 'GET_CODE_RANDOM_REQUEST';
export const GET_CODE_RANDOM_DONE = 'GET_CODE_RANDOM_DONE';
export const GET_CODE_RANDOM_FAILED = 'GET_CODE_RANDOM_FAILED';
